function categoryFactory($http) {
  function getParents() {
    return $http.get('/api/categories?parentId=0').then(response => response.data);
  }

  return { getParents };
}
categoryFactory.$inject = ['$http'];
export default categoryFactory;



// WEBPACK FOOTER //
// ./client/app/components/category/category.factory.js